export default __webpack_public_path__ + "static/media/cover7.b897923d.jpg";